import React from "react"
import { default as Layout } from "../templates/LayoutDefault"

const Topics = (props) => (
  <Layout>
    <h2>All Kind of Topics</h2>
  </Layout>
)

export default Topics



// WEBPACK FOOTER //
// ./src/pages/Topics.js